import { render, staticRenderFns } from "./RemarkListAddNew.vue?vue&type=template&id=99f40088&"
import script from "./RemarkListAddNew.vue?vue&type=script&lang=js&"
export * from "./RemarkListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./RemarkListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports